export const version = '5.8.6';
//# sourceMappingURL=version.js.map